import HmacSHA256 from "crypto-js/hmac-sha256";

export const hmacSHA256Hash = (str: string, secretKey: string): string =>
  HmacSHA256(str, secretKey).toString();
